import { Box } from '@mui/material';

export default function ServiceImagePreview({ file }) {
  if (!file) {
    return null;
  }

  const imgUrl = typeof file === 'string' ? file : file.preview;
  return (
    <Box
      component="img"
      src={imgUrl}
      sx={{
        zIndex: 8,
        overflow: 'hidden',
        position: 'absolute',
        width: `calc(100% - 16px)`,
        height: `calc(100% - 16px)`,
      }}
    />
  );
}
